const chan = typeof BroadcastChannel !== "undefined" ? new BroadcastChannel("omnifi-presenter") : null;

export function aiCue(question) {
  let text = "";
  const post = (done) => chan?.postMessage({ type: "ai", question, text, done, at: Date.now() });
  post(false);
  return { delta: (d) => { text += d; post(false); }, done: () => post(true) };
}
